import { motion } from 'framer-motion';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaExclamationTriangle, FaHome } from 'react-icons/fa';
import { Link, replace, useNavigate } from 'react-router-dom';

const Error404Screen = () => {

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="min-vh-100 bg-white d-flex align-items-center"
        >
            <Container fluid className="px-4">
                <Row className="justify-content-center">
                    <Col xs={12}>
                        <motion.div
                            initial={{ y: 30, opacity: 0, scale: 0.95 }}
                            animate={{ y: 0, opacity: 1, scale: 1 }}
                            transition={{ delay: 0.2, duration: 0.6 }}
                            className="text-center p-1"
                        >
                            {/* Error Icon */}
                            <motion.div
                                initial={{ scale: 0, rotate: -180 }}
                                animate={{ scale: 1, rotate: 0 }}
                                transition={{ delay: 0.4, duration: 0.8, type: "spring" }}
                                className="mb-2"
                            >
                                <div
                                    className="bg-light border rounded-circle d-inline-flex align-items-center justify-content-center"
                                    style={{
                                        width: '120px',
                                        height: '120px',
                                        border: '3px solid #e9ecef !important'
                                    }}
                                >
                                    <FaExclamationTriangle className="text-secondary" style={{ fontSize: '2rem' }} />
                                </div>
                            </motion.div>

                            {/* Error Number */}
                            <motion.h1
                                initial={{ y: 20, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ delay: 0.3, duration: 0.5 }}
                                className="fw-bold text-dark mb-3"
                                style={{ fontSize: '3rem' }}
                            >
                                404
                            </motion.h1>

                            {/* Title */}
                            <motion.h2
                                initial={{ y: 15, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ delay: 0.4, duration: 0.5 }}
                                className="fw-semibold text-dark mb-3"
                                style={{ fontSize: '1.5rem' }}
                            >
                                Page Not Found
                            </motion.h2>

                            {/* Go to Home Button */}
                            <motion.div
                                initial={{ y: 10, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ delay: 0.6, duration: 0.5 }}
                                className="mt-4"
                            >
                                <Link
                                    to='/'
                                    replace
                                    size="lg"
                                    className="px-4 py-3 fw-semibold btn btn-primary"
                                    style={{
                                        fontSize: '1rem',
                                        width: '200px'
                                    }}
                                >
                                    <FaHome className="me-2" />
                                    Go to Home
                                </Link>
                            </motion.div>
                        </motion.div>
                    </Col>
                </Row>
            </Container>
        </motion.div>
    );
};

export default Error404Screen;